import apiCall from '../../services/api';
import { put, takeEvery } from 'redux-saga/effects';
import {
  CHECK_ITEM_WISHLIST_STATUS,
  GET_WISHLIST_ITEM_COUNT_BY_USER,
  GET_WISHLIST_ITEMS_BY_CUSTOMER_INFO,
  SET_ITEM_WISHLIST_STATE,
} from '../actionTypes';
import { ENDPOINT } from 'src/config/endpoints';
import {
  saveWishlistData,
  saveWishlistItemCountByUser,
  WishlistAction,
} from '../actions/wishlist';

function* setItemWishlistState(actions: WishlistAction) {
  try {
    const response = yield apiCall({
      method: 'POST',
      url: ENDPOINT.WISHLIST.setItemWishlistStatus,
      data: actions.data,
    });
    if (response && response.data.status) {
      actions.callback && actions.callback(true);
    }
  } catch (err) {
    actions.callback && actions.callback(false, err?.data?.message);
    console.log(err);
  }
}

function* getWishlistItemsByCustomerInfo(actions: WishlistAction) {
  try {
    const response = yield apiCall({
      method: 'GET',
      url: ENDPOINT.WISHLIST.getWishlistItemsByCustomerInfo(
        actions?.data?.store_id,
        actions?.data?.phone
      ),
      parseToJson: true,
    });
    if (response && response.data.status) {
      yield put(saveWishlistData(response.data?.data));
      actions.callback && actions.callback(response.data?.data);
    }
  } catch (err) {
    actions.callback && actions.callback(false, err?.data?.message);
    console.log(err);
  }
}

function* checkItemWishlistStatus(actions: WishlistAction) {
  try {
    const response = yield apiCall({
      method: 'GET',
      url: ENDPOINT.WISHLIST.itemWishlistStatus(
        actions?.data?.store_id,
        actions?.data?.item_id
      ),
      parseToJson: true,
    });
    if (response && response.data.status) {
      actions.callback && actions.callback(response.data?.data);
    }
  } catch (err) {
    actions.callback && actions.callback(false, err?.data?.message);
    console.log(err);
  }
}

function* getWishlistItemCountByUser(actions: WishlistAction) {
  try {
    const response = yield apiCall({
      method: 'GET',
      url: ENDPOINT.WISHLIST.getWishlistItemCountByUser(actions.data?.store_id),
      parseToJson: true,
    });
    if (response && response.data.status) {
      yield put(saveWishlistItemCountByUser(response.data?.data));
      actions.callback && actions.callback(response.data?.data);
    }
  } catch (err) {
    actions.callback && actions.callback(false, err?.data?.message);
    console.log(err);
  }
}

export default function* root() {
  yield takeEvery(SET_ITEM_WISHLIST_STATE, setItemWishlistState);
  yield takeEvery(GET_WISHLIST_ITEMS_BY_CUSTOMER_INFO, getWishlistItemsByCustomerInfo);
  yield takeEvery(CHECK_ITEM_WISHLIST_STATUS, checkItemWishlistStatus);
  yield takeEvery(GET_WISHLIST_ITEM_COUNT_BY_USER, getWishlistItemCountByUser);
}
